import {
  Inventory as InventoryIcon,
  Inventory2 as Inventory2Icon,
  Assignment as AssignmentIcon,
  Settings as SettingsIcon,
  Assessment as AnalyticsIcon,
  AttachMoney as MoneyIcon,
  AccountBalance as FinanceIcon,
  LocalShipping as ShippingIcon,
  SmartToy as AiIcon,
} from '@mui/icons-material';

/**
 * Конфигурация меню навигации
 */
export const menuConfig = [
  {
    text: 'Комплектация',
    shortLabel: 'АРМ',
    icon: <AssignmentIcon />,
    path: '/fulfillment',
    children: [
      { text: 'АРМ кладовщика', path: '/fulfillment', perm: 'fulfillmentRead' },
      { text: 'Подбор заказов (ТСД)', path: '/fulfillment/picking', perm: 'fulfillmentPicking' },
      { text: 'Проклейка (ТСД)', path: '/fulfillment/labeling', perm: 'fulfillmentLabeling' },
      { text: 'Погрузка (ТСД)', path: '/fulfillment/loading', perm: 'fulfillmentLoading' },
      { text: 'Приёмка возвратов', path: '/returns/receiving', perm: 'returnsReceiving' },
      { text: 'Ozon разбивка', path: '/ozon/split', perm: 'ozonSplit' },
    ],
  },
  {
    text: 'Производство',
    shortLabel: 'Произв.',
    icon: <InventoryIcon />,
    path: '/production',
    children: [
      { text: 'Задания', path: '/production', perm: 'production' },
      { text: 'Весы', path: '/scale', perm: 'scale' },
      { text: 'Цех', path: '/production/next', permAny: ['production', 'scale'] },
      { text: 'Аналитика', path: '/production/analytics', perm: 'productionAnalytics' },
    ],
  },
  {
    text: 'Товары',
    shortLabel: 'Товары',
    icon: <Inventory2Icon />,
    path: '/analytics/products',
    children: [
      { text: 'Товары МП', path: '/analytics/products', perm: 'products' },
      { text: 'Товары МС', path: '/analytics/products/ms', perm: 'products' },
    ],
  },
  {
    text: 'Финансы',
    shortLabel: 'Финансы',
    icon: <FinanceIcon />,
    path: '/analytics/finance',
    children: [
      { text: 'Финансы', path: '/analytics/finance', perm: 'analyticsFinance' },
      { text: 'P&L (прибыли и убытки)', path: '/analytics/pnl', perm: 'analyticsPnl' },
    ],
  },
  {
    text: 'Аналитика',
    shortLabel: 'Аналит.',
    icon: <AnalyticsIcon />,
    path: '/analytics',
    children: [
      { text: 'Ежедневная', path: '/analytics/daily', perm: 'analyticsFinance' },
      { text: 'По артикулам', path: '/analytics/sales', perm: 'analyticsSales' },
      { text: 'Сводная по дням', path: '/analytics/pivot', perm: 'analyticsSales' },
      { text: 'Реклама', path: '/analytics/advert', perm: 'analyticsAdvert' },
      { text: 'Поиск', path: '/analytics/search', perm: 'analyticsSearch' },
      { text: 'Уведомления по отзывам', path: '/analytics/reviews-alarm', perm: 'reviewsAlarm' },
    ],
  },
  {
    text: 'Поставки',
    shortLabel: 'Поставки',
    icon: <ShippingIcon />,
    path: '/analytics/supply-plan',
    children: [
      { text: 'Планы продаж', path: '/analytics/plans', perm: 'salesPlans' },
      { text: 'Поставки FBO', path: '/analytics/supply-plan', perm: 'supplyPlanning' },
      { text: 'Планы поставок FBO', path: '/analytics/fbo-supply-plans', perm: 'supplyPlanning' },
      { text: 'Forecast Lab', path: '/analytics/forecast-lab', perm: 'forecastLab' },
      { text: 'Поставки', path: '/analytics/supplies', perm: 'analyticsSupplies' },
      { text: 'Закупки', path: '/analytics/purchasing', perm: 'purchasingDashboard' },
      { text: 'Остатки и себестоимость', path: '/analytics/stocks', perm: 'products' },
    ],
  },
  {
    text: 'AI',
    shortLabel: 'AI',
    icon: <AiIcon />,
    path: '/analytics/ai',
    children: [
      { text: 'AI-аналитик', path: '/analytics/ai', perm: 'aiAnalyst' },
      { text: 'AI Agent v2', path: '/analytics/ai-v2', perm: 'aiAnalyst' },
      { text: 'Конкуренты', path: '/analytics/competitors', perm: 'aiAnalyst' },
      { text: 'AI Approval Center', path: '/ai/approvals', perm: 'aiApprovals' },
      { text: 'AI Эффективность', path: '/analytics/ai-effectiveness', perm: 'aiEffectiveness' },
    ],
  },
  {
    text: 'Доход',
    shortLabel: 'Доход',
    icon: <MoneyIcon />,
    path: '/my-income',
    perm: 'myIncome',
  },
  {
    text: 'Настройки',
    shortLabel: 'Ещё',
    icon: <SettingsIcon />,
    path: '/settings',
    children: [
      { text: 'Сотрудники', path: '/settings/employees', perm: 'users' },
      { text: 'Ручной запуск', path: '/settings/manual', perm: 'settingsManual' },
      { text: 'Привязка чехлов', path: '/settings/covers-binding', perm: 'coversBinding' },
      { text: 'Аккаунты МП', path: '/settings/mp-accounts', perm: 'mpAccounts' },
      { text: 'Установки', path: '/settings/installations', perm: 'settingsManual' },
      { text: 'Калькулятор доставки', path: '/settings/dpd-calculator', perm: 'dpdCalculator' },
      { text: 'Cron-задачи', path: '/settings/cron-monitor', perm: 'cronAdmin' },
      { text: 'Безопасность AI', path: '/settings/ai-safety', perm: 'aiAutonomyConfig' },
      { text: 'Настройки печати', path: '/settings/printing', perm: 'printQueue' },
      { text: 'Print-agents', path: '/settings/print-agents', perm: 'printAgents' },
    ],
  },
];

/**
 * Получить отфильтрованное меню по правам пользователя
 */
export function getMenuItems(user) {
  if (!user) return [];

  const hasPerm = (permKey) => {
    if (!permKey) return true; // Если perm не указан - доступно всем
    if (user.role === 'admin') return true;
    return user.permissions?.[permKey] === true;
  };

  const station = user.is_station === true || user.is_station === 1 || user.is_station === '1';

  const childAllowed = (child) => {
    if (station) {
      if (child.path === '/production/next') return true;
      if (child.path === '/settings/printing') return user.permissions?.printQueue === true;
      return false;
    }
    if (Array.isArray(child.permAny) && child.permAny.length) {
      return child.permAny.some((key) => hasPerm(key));
    }
    return hasPerm(child.perm);
  };

  // Создаём глубокую копию чтобы не мутировать оригинал
  const items = menuConfig
    .filter((item) => !item.hidden)
    .map((item) => ({ ...item, children: item.children ? [...item.children] : undefined }));

  return items.filter((item) => {
    // Фильтруем children если есть
    if (item.children) {
      item.children = item.children.filter((child) => childAllowed(child));
      // Если есть children - показываем пункт если хотя бы один child доступен
      if (item.children.length === 0) return false;
      return true;
    }

    // Для пунктов без children - проверяем права напрямую
    if (station) return false;
    return hasPerm(item.perm);
  });
}
